import React from 'react';
import FormField from '../form-field';
import Input from '../input/Input';
import Icon from '../icon';
import { ICON_COLLECTION } from 'assets/media/icons';

import './InputWithSearchIcon.scss';
import Label from '../label';

type InputWithSearchIconProps = {
    placeholder?: string;
    className?: string;
    formClassName?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    hideClearButton?: boolean;
};

export default function InputWithSearchIcon({
    placeholder,
    className,
    formClassName,
    value,
    onChange,
    hideClearButton
}: InputWithSearchIconProps) {
    return (
        <FormField className={`input-with-search-icon ${formClassName}`}>
            <Label text={placeholder}></Label>
            <Input
                className={className}
                value={value}
                onChange={onChange}
                hideClearButton={hideClearButton === false ? hideClearButton : true}></Input>
            <Icon src={ICON_COLLECTION.IC_Search} className="search-icon"></Icon>
        </FormField>
    );
}
